const FALLBACK_LIMIT = 4096
let cached: number | undefined

/**
 * Query the GPU's MAX_TEXTURE_SIZE via a temporary WebGL context.
 * Result is cached after the first call. Falls back to 4096 if
 * WebGL is unavailable (headless environments, driver crash, etc.).
 */
export const getMaxTextureSize = (): number => {
  if (cached !== undefined) return cached
  try {
    const canvas = document.createElement('canvas')
    const gl =
      canvas.getContext('webgl') ?? canvas.getContext('experimental-webgl')
    if (gl && 'getParameter' in gl) {
      cached = (gl as WebGLRenderingContext).getParameter(
        (gl as WebGLRenderingContext).MAX_TEXTURE_SIZE
      ) as number
    } else {
      cached = FALLBACK_LIMIT
    }
  } catch {
    cached = FALLBACK_LIMIT
  }
  return cached
}
